import { EVENT_COUNT_LIMIT, MAX_ATTEMPTS } from './defaults';
import { type ResilienceOptions } from './types';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const createOptionsWithDefaults = (
	options: ResilienceOptions,
): Required<ResilienceOptions> => ({
	logger: options.logger || console,
	useMemory: options.useMemory || false,
	maxAttempts: options.maxAttempts || MAX_ATTEMPTS,
	// This is so that we can customise `maxEventLimit`, primarily for testing.
	maxEventLimit: options.maxEventLimit || EVENT_COUNT_LIMIT,
});
